import { Component, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from '../../services/tools.service';
import { NavigationService } from 'src/app/services/navigation.service';
import * as moment from 'moment';
import { filter } from 'rxjs';
import { AnimationService } from 'src/app/services/animation.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class HeaderComponent {
    @Input("reverseFab") reverseFab = false;
    currentLang: any;
    page: any;
    routeSubscription: any;
    kioskHeader: boolean = false;
    appHeader: boolean = false;

    constructor(
        public router: Router, 
        public translate: TranslateService, 
        public rest: RestService, 
        public tools: ToolsService, 
        public navigation: NavigationService,
        public animationService: AnimationService) {
            this.showKioskHeader();
            this.routeSubscription = this.router.events.pipe(
                filter(event => event instanceof NavigationEnd)
              ).subscribe((event: NavigationEnd) => {
                if (event.urlAfterRedirects.includes('home-kiosk')) this.showKioskHeader();
                if (event.urlAfterRedirects.includes('slides')) this.hideHeader();
                if (event.urlAfterRedirects.includes('license')) this.hideHeader();
                if (!event.urlAfterRedirects.includes('home-kiosk') && !event.urlAfterRedirects.includes('slides') && !event.urlAfterRedirects.includes('license')) this.showAppHeader();
            });
    }

    showKioskHeader(){
        this.kioskHeader = true;
        this.appHeader = false;
    }

    hideHeader(){
        this.kioskHeader = false;
        this.appHeader = false;
    }

    showAppHeader(){
        this.kioskHeader = false;
        this.appHeader = true;
    }

    ngOnInit() {
        this.currentLang = this.rest.langSelector?.find(e => e.code == this.translate.currentLang);
    }

    get CurrentUrl(){
        return this.router.url
    }

    goBack(){
        if (this.router.url != this.rest.redirectPage){
            // history.back()
            this.animationService.setAnimationType('slideInvertedAnimation');
            setTimeout(() => {
                this.navigation.goBack()
            }, 15);
            
        }
    }

    get logo(){
        return this.rest?.device?.logo?.value;
    }

    clickButton(e, msg){
        e.preventDefault();
        this.rest.sendData(msg);
    }

    changeLanguage(lang){
        moment.locale(lang);
        this.translate.setDefaultLang(lang);
        this.translate.use(lang);
        this.currentLang = this.rest.langSelector?.find(e => e.code == lang);
    }

    myCustomRouteShowHeader(){
        return this.rest.myCustomRouteShowHeader
    }

    showClientRouteInfo(){
        return this.rest.myCustomRoute.showClientRouteInfo;
    }

    ngOnDestroy(){
        if (this.routeSubscription) this.routeSubscription.unsubscribe();
    }

}